import { Container, Button, ProductImage } from "@/components/atoms";
import { Differentiators } from "@/components/sections";
import { Seo } from "@/components/seo";

export default function About() {
  return (
    <>
      <Seo
        title="About Dr. Burns"
        path="/about"
        description="Meet Dr. Elaine Burns — Arizona-licensed Naturopathic Physician and AACM-Certified founder of DrBurns’ ReLeaf."
      />

      <section className="bg-gradient-to-br from-medical-grey to-healthy-blue/5 py-12">
        <Container className="grid items-center gap-10 md:grid-cols-2">
          <div>
            <span className="font-condensed text-xs font-bold uppercase tracking-widest text-leaf-green-ink">
              Our Founder
            </span>
            <h1 className="mt-2 font-condensed text-4xl font-bold text-night-blue">
              Dr. Elaine Burns
            </h1>
            {/* Bio sourced from Dr. Burns' own evaluationtoday.com/about-us at her request
                (2026-08-11: "can you take the info about me from EvaluationToday.com?"). */}
            <p className="mt-4 text-night-blue/70">
              An Arizona-licensed Naturopathic Physician who has served Arizona
              patients since 2011, and the first in the state to pass the
              American Academy of Cannabinoid Medicine (AACM) physician
              certification test in 2012.
            </p>
            <p className="mt-3 text-night-blue/70">
              Dr. Burns is widely recognized as one of Arizona&rsquo;s leading
              advocates for the patients who benefit most from cannabinoid
              therapy, and she is the founder and medical director of Southwest
              Medical Marijuana Evaluation.
            </p>
            <Button to="/shop" className="mt-5">
              Shop Her Formulas
            </Button>
          </div>
          <div className="w-full max-w-sm rounded-[20px] bg-gradient-to-br from-healthy-blue via-healthy-blue/80 to-leaf-green/70 p-1 shadow-[0_14px_40px_rgba(60,113,184,0.24),0_4px_12px_rgba(0,0,0,0.08)]">
            <ProductImage
              src="https://firebasestorage.googleapis.com/v0/b/drburns-web.firebasestorage.app/o/about%2Fdr-burns.png?alt=media"
              alt="Dr. Elaine Burns"
              name="Dr. Elaine Burns"
              className="aspect-square w-full !rounded-2xl bg-gradient-to-br from-medical-grey to-white"
              imgClassName="object-cover object-top"
            />
          </div>
        </Container>
      </section>

      <Container className="prose-section grid gap-8 py-12 md:grid-cols-2">
        <div>
          <h2 className="mb-2 font-condensed text-2xl font-bold text-night-blue">
            Our Mission
          </h2>
          <p className="text-night-blue/70">
            Our mission is to ensure patients have access to consistently
            high-quality therapeutic products rooted in science, not folklore.
            Our proprietary formulas result in safe, effective, and economical
            treatment options by combining CBD with other superior botanicals to
            provide tailored effects.
          </p>
        </div>
        <div>
          <h2 className="mb-2 font-condensed text-2xl font-bold text-night-blue">
            The Philosophy
          </h2>
          <p className="text-night-blue/70">
            DrBurns’ ReLeaf™ is a physician-formulated CBD wellness collection
            designed for various conditions such as arthritis, migraines, and GI
            issues. Rooted in science, the product line has achieved a 99.5%
            accuracy rating by CBD Informative.
          </p>
        </div>
      </Container>

      {/* Background + education, from evaluationtoday.com/about-us at Dr. Burns' request (2026-08-11). */}
      <Container className="prose-section grid gap-8 pb-12 md:grid-cols-2">
        <div>
          <h2 className="mb-2 font-condensed text-2xl font-bold text-night-blue">
            Her Background
          </h2>
          <p className="text-night-blue/70">
            Since 2011, Dr. Burns has been instrumental in building an ethical,
            highly professional medical cannabis industry in Arizona. She
            believes educating both patients and physicians on the safety and
            efficacy of cannabinoids is paramount to providing the best care,
            and she is passionate about helping others achieve wellness and
            vitality in their lives.
          </p>
        </div>
        <div>
          <h2 className="mb-2 font-condensed text-2xl font-bold text-night-blue">
            Education
          </h2>
          <ul className="ml-4 list-disc text-night-blue/70 [&>li]:mt-1">
            <li>Doctorate in Naturopathic Medicine</li>
            <li>
              Bachelor&rsquo;s in Psychology and Pre-med, University of Delaware
            </li>
            <li>Master&rsquo;s in Business, University of Phoenix</li>
            <li>AACM physician certification, 2012 (first in Arizona)</li>
          </ul>
        </div>
      </Container>

      <Differentiators />
    </>
  );
}
